import React, { useEffect, useRef } from "react";
const MiddleEllipsis = (props) => {
    const ref = useRef(null);
    const prepEllipse = (node) => {
        const parent = node.parentNode;
        const child = parent.querySelector(".constrainedChild") || node.childNodes[0];
        const txtToEllipse = parent.querySelector(".ellipseMe") ||
            parent.querySelector(".constrainedEllipse") ||
            child;
        if (child && txtToEllipse) {
            if (txtToEllipse.hasAttribute("data-original")) {
                txtToEllipse.textContent = txtToEllipse.getAttribute("data-original");
            }
            ellipse(node.offsetWidth > parent.offsetWidth ? parent : node, child, txtToEllipse);
        }
    };
    const measuredParent = (node) => {
        if (node) {
            window.addEventListener("resize", () => prepEllipse(node));
            prepEllipse(node);
        }
    };
    useEffect(() => {
        if (ref.current) {
            measuredParent(ref.current);
        }
    }, [ref.current]);
    return (React.createElement("div", { ref: ref, style: {
            wordBreak: "keep-all",
            overflowWrap: "normal",
            ...(props.width && { width: props.width }),
        } }, props.children));
};
const ellipse = (parentNode, childNode, txtNode) => {
    const childWidth = childNode.offsetWidth;
    const containerWidth = parentNode.offsetWidth;
    const txtWidth = txtNode.offsetWidth;
    const targetWidth = childWidth > txtWidth ? childWidth : txtWidth;
    if (targetWidth > containerWidth) {
        const str = txtNode.textContent || '';
        const txtChars = str.length;
        const avgLetterSize = txtWidth / txtChars;
        const canFit = (containerWidth - (targetWidth - txtWidth)) / avgLetterSize;
        const delEachSide = (txtChars - canFit + 5) / 2;
        const endLeft = Math.floor(txtChars / 2 - delEachSide);
        const startRight = Math.ceil(txtChars / 2 + delEachSide);
        txtNode.setAttribute("data-original", txtNode.textContent || '');
        txtNode.textContent = str.substr(0, endLeft) + "..." + str.substr(startRight);
    }
};
export default MiddleEllipsis;
